import { Box, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { themeConfig } from '..'

function ResponseCard({ m }: any) {
  return (
    <Box
      textAlign='left'
      maxW='400px'
      px={5}
      py={5}
      mb={3}
      rounded='lg'
      borderWidth={1}
      borderColor={themeConfig.colors.green4}
      bg={themeConfig.colors.yellowgreen3}
    >
      <Text>From: {m.from}</Text>
      <Text>Msg: {m.msg_body}</Text>
      <Text>
        Date:{' '}
        {new Date(m.timestamp.T).toLocaleTimeString() +
          '__' +
          new Date(m.timestamp.T).toLocaleDateString()}
      </Text>
    </Box>
  )
}

export function WhatsAppResponses() {
  const [messages, setMessages] = useState<Array<any>>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    async function fet() {
      const res = await fetch(
        'https://messaging.thesmalldatastore.com/get_received',
      )
      const body = await res.json()
      setMessages(body)
      setLoading(false)
    }

    fet()
  }, [])

  function compState() {
    if (loading) {
      return <Text>Loading...</Text>
    } else if (messages.length === 0) {
      return <Text>No messages</Text>
    } else {
      return (
        <Box overflowY='scroll' h='calc(100% - 50px)'>
          {messages.map((m) => (
            <ResponseCard m={m} key={m._id} />
          ))}
        </Box>
      )
    }
  }

  return (
    <Box w='full' display='flex' justifyContent='center'>
      <Box
        w='1/2'
        minW={400}
        borderWidth={1}
        textAlign='center'
        px={5}
        py={5}
        h='calc(100vh - 120px)'
      >
        <Text mb={5} fontWeight='bold'>
          WhatsApp Responses
        </Text>

        {compState()}
      </Box>
    </Box>
  )
}
